
export const PageStatAction = {
    STAY_DURATION: 'STAY_DURATION',
    SCROLL_SCREEN: 'SCROLL_SCREEN',
}

